import { render } from "./ImgPreview.vue?vue&type=template&id=9c2b68c2"
import script from "./ImgPreview.vue?vue&type=script&lang=js"
export * from "./ImgPreview.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=9c2b68c2&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script